module.exports = __webpack_public_path__ + "static/media/mintrabajo.ae6fe8b0.png";